<!-- @if(!JobID()){
  <div class="bg-[#eeeee] min-h-[100vh]">
  </div>
}
       
  @if(((isProUser() && fromApplied()) || (isShow()) && !isClosed())){
  @if(jobDetails()?.JObIMage){
    <div class="bg-[#eee]">
      <app-newspaper-job-details
        [jobDetails]="jobDetails()"
        [jobList]="moreJobs()"
        >
      </app-newspaper-job-details>
    </div>
  }@else{
  <div #topElement class="pb-6 bg-[#EEEEEE] rounded " *transloco="let t; currentLang as currentLang">
    <div class="lg:pt-5 pt-5">
      <div class="card flex">
        <div class=" font-inter card-header px-0 sm:px-0 mx-auto sm:w-full w-[100%] lg-width-full md:w-[720px] xl-width-full xl:px-0  flex items-start  gap-2 ">
          <div class="border border-[#ddddd9] rounded px-4 py-6 bg-white sm:p-5 md:w-[550px] lg-width md:pt-5  sm:w-[96%]  lg:mx-0 xl-width  w-[100%] shadow-lg">
            <div class=" flex flex-col ">
              <div class=" text-start  py-2.5 rounded-md  min-w-full">
                <button [routerLink]="jobs_url" [queryParams]="{isBack: true}" [class.hidden]="isCorporate()" class="no-print cursor-pointer">
                  <span class="flex gap-1.5 items-center cursor-pointer font-semibold text-[#475467]">
                    <img [src]="environment.homeImageUrl + 'icon-down.svg'" class="rotate-90 w-5 h-5"/>
                    <span>{{t('jobList')}}</span>
                  </span>
                </button>
              </div>
              <div class=" min-h-screen">
                <div [ngClass]="(isProUser() ===true)? 'flex flex-row justify-between':'flex justify-between'">
                  <div [ngClass]="(isProUser() === true)? 'mt-4 flex flex-col-reverse flex-wrap':'flex flex-col-reverse'">
                    <div class="flex-1">
                      <button class="flex gap-1 cursor-pointer"  [routerLink]="canNavigateToCompanyInsight() ? '/company-insight/' + jobDetails()?.CompanyID : null" [state]="{'details': 'details'}">
                        <h2 appHighlight [searchText]="searchQuery()"
                        [class.hover:underline]="canNavigateToCompanyInsight()"
                          class="flex items-baseline gap-[2px] sm:gap-[2px]  cursor-pointer min-w-0 text-left bg-transparent border-none p-0 box-border font-inherit leading-[1.1] m-0 text-xs sm:text-[20px] font-semibold text-[#333] relative z-[99]">
                          {{ jobDetails()?.CompnayName }}<span></span>
                        </h2>
                        <img [src]="environment.homeImageUrl + 'company-name-share-details.gif'" alt="share icon" [class.hidden]="!canNavigateToCompanyInsight()"
                          class="-mt-2 block w-[55px] h-[20px] sm:w-[84px] sm:h-[26px] translate-y-[5px] sm:translate-y-[6px]  " />
                      </button>


                      <h2 appHighlight [searchText]="searchQuery()" class="mb-2.5 text-sm sm:mt-[4px] sm:text-[24px] lg:text-[24px] font-semibold text-[#2F64A3]">
                      {{ jobDetails()?.JobTitle }}
                      </h2>
                      @if((jobDetails()?.AccessibilityAware?.length ?? 0) > 0 && isDisabilityUser()){
                        <div (click)="scrollToBottom()" class="cursor-pointer flex items-center gap-2 text-xs sm:text-sm text-[#333] mb-1">
                          <img [src]="environment.homeImageUrl + 'abdg.png'" alt="">
                          <p class="block">{{t('accessAware')}}</p>
                        </div>
                      }
                    </div>
                    @if(jobDetails()?.JobLOgoName){
                    <div class=" mb-2.5">
                      <img class="max-w-[150px] max-h-[100px] border border-[#E4E7EC] shadow-sm  rounded-[6px]" [src]="jobDetails()?.JobLOgoName" alt="">
                    </div>
                    }
                  </div>
                  @if(isProUser() && matchingApiCalled()){
                  <div
                    [class.opacity-100]="isTooltipVisible() && isMobileDevice()"
                    [class.pointer-events-auto]="isTooltipVisible() && isMobileDevice()"
                    [class.opacity-0]="!isTooltipVisible() || !isMobileDevice()"
                    [class.pointer-events-none]="!isTooltipVisible() || !isMobileDevice()"
                    (click)="isTooltipVisible.set(!isTooltipVisible())"
                    class="fixed inset-0 bg-black/50 transition-opacity duration-300 z-[999998] sm:hidden"
                  ></div>
                  <div (click)="isMobileDevice() && isTooltipVisible.set(!isTooltipVisible())" class="no-print -mt-2 sm:mr-10 mr-0 self-start relative group">
                    @if(isBrowser){
                        @defer (on viewport) {
                          <div class="pb-10">
                            <app-gauge-meter
                              [value]="applicantMatchingScore()"
                              [isMandatoryUnmatched]="hasMandatoryUnmatched()"
                              [labelLow]="t('low')"
                              [labelMedium]="t('medium')"
                              [labelHigh]="t('high')">
                            </app-gauge-meter>
                          </div>

                        } @placeholder {
                          <div class="h-28"></div>
                        }
                        @if(applicantMatchingScore() > -100 && !hasMandatoryUnmatched()){
                          <span class="absolute text-[8px] top-[74px] left-[3px] md:text-[10px] md:per_0 md:bottom-6 md:top-[110px] md:left-[7px]">{{ currentLang === 'bn' ? (0 | toBanglaNumber) : 0 }}%</span>
                          <span class="absolute text-[8px] top-[74px] -right-[3px] md:text-[10px] md:per_100 md:bottom-6 md:top-[110px] md:right-0">{{ currentLang === 'bn' ? (100 | toBanglaNumber) : 100 }}%</span>
                        }
                          @if(applicantMatchingScore() > -100 && !hasMandatoryUnmatched()){
                            <span
                              class="absolute top-5 right-2 text-[8px] sm:right-[31px] sm:top-[126px]  sm:text-[10px] font-semibold top-[87px] right-3 md:text-black text-[#797979]">
                                {{t('matched')}}
                                {{currentLang === 'bn' ? (applicantMatchingScore() | toBanglaNumber) : applicantMatchingScore()}}%
                            <span
                                class="icon-info text-[10px] sm:text-xs text-[#475467]"></span>

                            </span>
                          }@else {
                            <div>
                              <span
                              [class.sm:right-[30px]]="currentLang === 'bn'"
                              class="text-[#475467]  absolute top-20 -right-4 text-[10px] sm:text-[10px] font-semibold sm:right-[18px] sm:top-[120px] matched matched-dis">
                                  {{t('notGeneratedYet')}}
                               <span
                                class="icon-info text-[10px] sm:text-xs text-[#475467]"></span>
                             </span>
                            </div>

                          }
                      }
                      <div
                      [class.translate-y-0]="isTooltipVisible() && isMobileDevice()"
                      [class.translate-y-[150%]]="!isTooltipVisible() && isMobileDevice()"
                      [ngClass]="applicantMatchingScore() === -100 || hasMandatoryUnmatched() ? 'tooltip text-[14px] sm:text-xs w-full sm:w-[220px] p-1.5 sm:p-0 sm:top-[146px] sm:left-[35%] sm:-translate-x-1/2':
                      'sm:w-[368px] w-full sm:top-[152px] sm:left-[3%] sm:-translate-x-1/2 text-xs'"
                     class="text-[#333] z-[999999999] tooltip border border-[#ddd] block sm:hidden sm:group-hover:block bg-white box-shadow fixed bottom-0 left-0 rounded-t-[20px] rounded-b-none sm:rounded-[10px] sm:absolute sm:bottom-auto pb-4 sm:pb-0 transition-transform duration-300 ease-in-out sm:transition-none sm:translate-y-0"
                      [class.sm:w-[240px]] = "hasMandatoryUnmatched()" >

                      @if(applicantMatchingScore() === -100){
                        <div class=" p-4 sm:p-4">
                          <p>{{t('matching_percentage_message')}}</p>
                        </div>
                      }

                      @else if(hasMandatoryUnmatched()){
                        <div class=" p-4 sm:p-4">
                          <p>{{t('unmatchedMandatory')}}</p>
                        </div>
                      }
                      @else {
                        <div class="">
                          <div class="flex justify-between items-center mb-3 px-6 pt-4">
                            <p class="text-[#101828] font-semibold text-lg">{{t('matchDetails')}}</p>
                            <div class="flex items-center gap-1">
                              <img [src]="environment.homeImageUrl + 'speedometer.svg'" />
                              <span class="text-[#C63C92] font-bold text-xl">
                                {{currentLang === 'bn' ? (applicantMatchingScore() | toBanglaNumber) : applicantMatchingScore()}}%
                              </span>
                            </div>
                          </div>
                          <div class="border-b border-[#D0D5DD]"></div>
                          <div class="px-6 py-4 flex items-center justify-between">
                            <p class="text-[#B32D7D] font-medium text-xs">{{t('Requirement')}}</p>
                            <p class="text-[#B32D7D] font-medium text-xs">{{t('summary')}}</p>
                          </div>
                          @for(item of MatchingList(); track $index; let i = $index){
                            <div
                              [class.hidden]="item.status !== matchingStatus.notGenerateYet"
                              class="px-3.5 flex items-center justify-center w-full gap-2">
                                <div class="flex-1 border-b border-[#D0D5DD]"></div>
                                <p class="text-[#344054] text-[10px] font-medium whitespace-nowrap">
                                  {{t('willBeCalculated')}}
                                </p>
                                <div class="flex-1 border-b border-[#D0D5DD]"></div>
                            </div>
                            <div
                              [class.bg-white]="i % 2 !== 0"
                              class="mx-3 py-4 mb-2 flex flex-col gap-2 bg-[#F9FAFB] rounded-md">
                              <div class="px-3 flex items-center justify-between ">
                                  <p class="text-[#101828] font-medium text-sm">{{item.criteriaName | transloco }}</p>
                                  <p
                                    [style.backgroundColor]="item.bgColor"
                                    [style.borderColor]="item.borderColor"
                                    [style.color]="item.textColor"
                                    class="border  px-2 py-0.5 rounded-full  text-[10px]">
                                    {{item.status| transloco}}
                                  </p>
                              </div>
                              @if( item.status === matchingStatus.partlyMatched && item.criteriaName ==='Experience'){
                                <p class="flex items-center gap-1 mx-3">
                                  <img [src]="environment.homeImageUrl + 'alert-triangle.svg'"/>
                                  <span class="text-[10px] text-[#DC6803]">{{item.statusReason | transloco}}</span>
                                </p>
                              }
                            </div>
                          }
                        </div>
                      }
                      <div
                         [ngClass]="applicantMatchingScore() === -100 || hasMandatoryUnmatched() ? 'right-[22px]':'right-16'"
                        class="md:block hidden rotate-180 absolute -translate-x-1/2 -top-2.5  w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-[#ddd]">
                      </div>
                      <div
                      [ngClass]="applicantMatchingScore() === -100 || hasMandatoryUnmatched() ? 'right-6':'right-[66px]'"
                        class="md:block hidden rotate-180 absolute -translate-x-1/2 -top-2  w-0 h-0 border-l-8 border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-white">
                      </div>
                    </div>

                  </div>
                  }
                  @else{
                    @if(isBrowser && isProUser() === false){
                      <a (click)="redirectToPricingPage()" class="cursor-pointer mb-4 md:block hidden hover:shadow-sm max-h-fit rounded-md rounded-md">
                        <img [src]="environment.homeImageUrl + 'matching_lock_' + (currentLang === 'en' ? 'en' : 'bn') + '.webp'" alt="">
                      </a>
                      <a (click)="redirectToPricingPage()" class="cursor-pointer block md:hidden w-full mb-4 max-w-[100px]">
                        <img [src]="environment.homeImageUrl + 'matching_lock_' + (currentLang === 'en' ? 'en' : 'bn') + '_res.svg'" alt=""
                          class="ml-2 block w-auto max-w-[100px] h-auto object-contain" />
                      </a>

                    }

                  }
                </div>
                <div class="sticky top-0 bg-white z-[999]">
                  <div [ngClass]="!jobDetails()?.JobLOgoName && (isProUser())?'md:-mt-3 lg:-mt-10':'mt-0'"
                    class=" flex flex-col lg:flex lg:flex-row lg:justify-between sm:gap-1 gap-2">
                    <div class="lg:mt-2 md:self-start flex items-center gap-1 ">
                      <p class=" text-xs sm:text-sm font-normal">{{t('Application_Deadline')}} :</p>
                      <p class="text-xs sm:text-sm font-semibold text-[#B32D7D]">
                        {{currentLang === 'bn' ? ((jobDetails()?.Deadline | date:'dd MMM yyyy') ?? '' | toBanglaNumber):jobDetails()?.Deadline | date:'dd MMM yyyy'}}
                      </p>
                    </div>
                    <div class="no-print flex flex-col sm:flex-row justify-end items-end gap-[5px] mb-3">
                      <div class="flex gap-1.5 sm:flex sm:flex-row sm:gap-1.5 mt-2">
                        @if(jobDetails()?.OnlineApply !=="False" && !remainingData().IsApplied){
                            <button
                            [routerLink]=" shouldNotNavigateToApplyOnline() ? null : '/apply-online/'+ jobDetails()?.JobId"
                              data-testid="applyNowBtn"
                              (click)="!shouldNotNavigateToApplyOnline() && applyOnline()"
                              class="bg-[#008020] hover:bg-[#02651C] max-h-[40px] text-white text-sm font-medium py-[11px] px-3 rounded cursor-pointer">
                              {{t('Apply_Now')}}
                            </button>
                        }
                        @if(remainingData().IsApplied){
                          <button
                            class=" flex items-center gap-[5px] px-4 py-2 font-medium border-2 border-[#f3e5f5] bg-[#fefbfe] text-[#a553b3] rounded sm:text-sm text-xs">
                            <span class="icon-check-sign"></span>
                            {{t('Already_Applied')}}
                          </button>
                        }
                        <div>
                          <button (click)="shortLists()"
                            class="flex max-h-[40px] items-center gap-[5px] bg-white border border-[#95CDFF] text-sm font-medium py-2.5 px-4 text-[#333] rounded cursor-pointer">
                            <span [ngClass]="IsShortlistedLocal() ? 'text-[#2F64A3]':'text-[#595959]'" class="icon-star mr-1"></span>
                            {{ IsShortlistedLocal() ? t('remove') : t('shortListed') }}
                          </button>
                        </div>
                      </div>
                      <div class="flex gap-[5px]">
                        <div
                          class="max-h-[40px] flex justify-center items-center gap-[5px] border border-[#95CDFF] rounded py-2 px-5 font-medium text-sm text-[#333]">
                          <p class="flex justify-center items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
                              <path
                                d="M11.0043 9.98438C10.7451 9.98438 10.5054 10.0273 10.2851 10.1133C10.0648 10.1992 9.86825 10.3125 9.69546 10.4531L4.93952 7.94531C4.9568 7.875 4.97192 7.80664 4.98488 7.74023C4.99784 7.67383 5.00432 7.60156 5.00432 7.52344C5.00432 7.45312 4.99784 7.38281 4.98488 7.3125C4.97192 7.24219 4.9568 7.17188 4.93952 7.10156L9.64363 4.62891C9.81641 4.77734 10.0194 4.89648 10.2527 4.98633C10.486 5.07617 10.7365 5.12109 11.0043 5.12109C11.5486 5.12109 12.0173 4.94336 12.4104 4.58789C12.8035 4.23242 13 3.80469 13 3.30469C13 2.80469 12.8035 2.37891 12.4104 2.02734C12.0173 1.67578 11.5486 1.5 11.0043 1.5C10.4514 1.5 9.9784 1.67578 9.58531 2.02734C9.19222 2.37891 8.99568 2.80469 8.99568 3.30469C8.99568 3.38281 9.00216 3.45508 9.01512 3.52148C9.02808 3.58789 9.0432 3.65625 9.06048 3.72656L4.35637 6.21094C4.18359 6.05469 3.98056 5.93359 3.7473 5.84766C3.51404 5.76172 3.2635 5.71875 2.99568 5.71875C2.4514 5.71875 1.98272 5.89453 1.58963 6.24609C1.19654 6.59766 1 7.02344 1 7.52344C1 8.02344 1.19654 8.45117 1.58963 8.80664C1.98272 9.16211 2.4514 9.33984 2.99568 9.33984C3.2635 9.33984 3.51404 9.29492 3.7473 9.20508C3.98056 9.11523 4.18359 8.99609 4.35637 8.84766L9.11231 11.3438C9.09503 11.4062 9.07991 11.4707 9.06695 11.5371C9.054 11.6035 9.04752 11.6719 9.04752 11.7422C9.04752 12.2266 9.23758 12.6406 9.61771 12.9844C9.99784 13.3281 10.46 13.5 11.0043 13.5C11.54 13.5 11.9978 13.3281 12.378 12.9844C12.7581 12.6406 12.9482 12.2266 12.9482 11.7422C12.9482 11.2578 12.7581 10.8438 12.378 10.5C11.9978 10.1562 11.54 9.98438 11.0043 9.98438Z"
                                fill="#0E73A9" />
                            </svg>
                            {{t('Share')}}:
                          </p>
                          <div class="relative group">
                            <a (click)="detailsUtilService.socialMediaShare(facebookUrl,jobUrl)"
                              class="flex items-center justify-center rounded-full bg-[#1877F2] w-6 h-6 cursor-pointer">
                              <span class="icon-facebook text-white text-xs text-center"></span>
                            </a>
                            <div
                              class="absolute left-1/2 bottom-[80%] mb-3 w-max -translate-x-1/2 px-2 py-1 rounded bg-black text-white text-[12px] hidden group-hover:block transition-opacity">
                              Facebook
                              <div
                                class="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-black">
                              </div>
                            </div>
                          </div>

                          <div class="relative group">
                            <a (click)="detailsUtilService.socialMediaShare(linkedinUrl,jobUrl)"
                              class="flex items-center justify-center rounded-full bg-[#0077B5] w-6 h-6 cursor-pointer">
                              <span class="icon-linkedin text-white text-xs text-center"></span>
                            </a>
                            <div
                              class="absolute left-1/2 bottom-[80%] mb-3 w-max -translate-x-1/2 px-2 py-1 rounded bg-black text-white text-[12px]  hidden group-hover:block transition-opacity">
                              LinkedIn
                              <div
                                class="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-black">
                              </div>
                            </div>
                          </div>

                          <div class="relative group">
                            <a (click)="detailsUtilService.socialMediaShare(whatsappUrl,jobUrl,'Check out this job!')"
                              class="flex items-center justify-center rounded-full bg-[#25D366] w-6 h-6 cursor-pointer">
                              <span class="icon-whatsapp text-white text-xs text-center"></span>
                            </a>
                            <div
                              class="absolute left-1/2 bottom-[80%] mb-3 w-max -translate-x-1/2 px-2 py-1 rounded bg-black text-white text-[12px] hidden group-hover:block transition-opacity">
                              WhatsApp
                              <div
                                class="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-black">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <span (click)="detailsUtilService.triggerPrint()"
                            class="flex max-h-[40px] items-center justify-center gap-[5px] border border-[#95CDFF] rounded-md px-4 py-3 text-[#595959] icon-printer text-sm cursor-pointer"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="no-print flex justify-center items-center mb-4">
                    <button
                      (click)="canScrollLeft() ? scrollLeft() : null; selectButton('left')"
                      [ngClass]="{
                        'scroll-button': true,
                        'selected': selected() === 'left' && canScrollLeft(),
                        'not-selected': selected() !== 'left' || !canScrollLeft(),
                        'disabled-btn': !canScrollLeft(),
                        'cursor-not-allowed': !canScrollLeft()
                      }"
                      class="cursor-pointer p-[14px] icon-angle-left-o mr-4 border text-xs w-10 h-10 flex justify-center items-center rounded-full transition">
                    </button>

                    <div class=" w-full text-sm flex navigation-container overflow-x-auto no-scrollbar" #navigationContainer>
                      <ng-container>
                        <div class=" flex min-w-full">
                          @for (section of sections; track $index) {
                          <div [ngClass]="{'hidden': !section.condition}" class="w-full flex flex-wrap">
                            @if(section.condition){
                            <button
                            #sectionButton
                            (click)="scrollToSection(section.id)"
                              [ngClass]="{
                                'bg-[#CCE7FF] font-medium text-[#2F64A3] border-none': selectedSection === section.id,
                                'bg-[#F4F4F4] font-medium text-[#595959] border-l border-[#ddd]': selectedSection !== section.id,
                              }"
                              class="cursor-pointer sm:w-full w-full max-w-[400px] ml-0 block sm:mx-0 sm:max-w-[450px]  px-[22px] py-2.5   whitespace-nowrap border  border-[#dddddd] border-l-0">
                              {{ section.label | transloco}}
                            </button>
                            }
                          </div>
                          }
                        </div>
                      </ng-container>
                    </div>
                    <button
                      (click)="canScrollRight() ? scrollRight() : null; selectButton('right')"
                      [ngClass]="{
                        'scroll-button': true,
                        'selected': selected() === 'right' && canScrollRight(),
                        'not-selected': selected() !== 'right' || !canScrollRight(),
                        'disabled-btn': !canScrollRight()
                      }"
                      class="cursor-pointer p-[14px] icon-angle-left-o rotate-180 ml-4 border text-xs w-10 h-10 flex justify-center items-center rounded-full transition">
                    </button>
                  </div>
                  <hr class="bg-[#DDDDDD] w-full mb-3">
                </div>
                <app-summary
                  [jobDetails]="jobDetails()">
                </app-summary>
                @if (jobDetails()?.PreferVideoResume !== 0) {
                  <div
                    class="m-0 mb-2.5 px-5 py-2.5 flex items-center gap-2 rounded border-[0.5px] border-[#95CDFF] bg-[#ECF6FF] text-[#2F64A3] text-sm sm:text-base font-normal font-inter">
                    @if(transloco.getActiveLang() === 'en'){
                      <p>Applicants are encouraged to submit <b>Video CV.</b></p>
                    }@else {
                      <p>অ্যাপ্লিকেন্টদের <b>ভিডিও সিভি</b> সাবমিট করতে উৎসাহিত করা হচ্ছে।</p>
                    }
                  </div>
                }
                <div class="no-print">
                  @defer (on viewport) {
                    <app-application-insights
                      [topApplicantMatchingPercentage]="topApplicantMatchingPercentage()"
                      [applicantMatchingScore]="applicantMatchingScore()"
                      [isApplied]="remainingData().IsApplied"
                      [(matchingData)]="matchingData">
                    </app-application-insights>
                  } @placeholder {
                    <div class="h-48"></div>
                  }
                </div>
                @defer (on viewport) {
                  <app-details-main
                    [keyword]="searchQuery()"
                    [jobDetails]="jobDetails()">
                  </app-details-main>
                } @placeholder {
                  <div class="h-[500px]"></div>
                }

                @if(jobDetails()?.JobKeyPoints){
                  <div class="bg-[#ECF6FF] mb-4 px-3 sm:px-5 py-2.5 border border-[#95CDFF] rounded">
                    <p class="mb-2.5 text-[#B32D7D] text-xs sm:text-base font-semibold">{{t('job_highlights')}}</p>
                    <div class="sm:leading-8 leading-5 sm:text-sm text-xs" [innerHTML]="jobDetails()?.JobKeyPoints">
                    </div>
                  </div>
                }
                @if(jobDetails()?.ApplyInstruction){
                  <div class="bg-[#F4F4F4] mb-4 px-3 sm:px-5 py-3 border border-[#DDD] rounded">
                    <p class="mb-2 text-[#B32D7D] text-sm sm:text-base font-semibold">
                      {{t('read_before_apply')}}
                    </p>
                    <div class="sm:leading-7 leading-5 sm:text-sm text-xs text-[#333]"
                      [innerHTML]="jobDetails()?.ApplyInstruction">
                    </div>
                  </div>
                }

                @if(jobDetails()?.ApplyEmail || jobDetails()?.ApplyURL
                || jobDetails()?.WalkInInterview || jobDetails()?.HardCopy){
                  <div class="border border-[#ddd] rounded px-3 sm:px-5 py-4 mb-4">
                    <p class="mb-2 text-[#B32D7D] text-sm sm:text-base font-semibold">{{t('apply_procedure')}}</p>
                    @if(jobDetails()?.ApplyEmail){
                      <p class="mb-2 text-[#B32D7D] text-sm sm:text-base font-semibold">{{t('email_your_cv')}}</p>
                      <p class="text-xs sm:text-sm text-[#333]">
                        <span>{{detailsUtilService.getTextSegments(jobDetails()?.ApplyEmail ?? '').emailText}}</span>
                        @if(detailsUtilService.getTextSegments(jobDetails()?.ApplyEmail ?? '').strongText){
                          or Email your CV from <a
                            [href]="`${emailCvUrl}?id=${jobDetails()?.JobId}&lang=${currentLang}`"
                            target="_blank"
                            class="font-bold text-[#2F64A3] cursor-pointer">{{detailsUtilService.getTextSegments(jobDetails()?.ApplyEmail
                            ?? '').strongText}}</a>
                          account
                        }
                      </p>
                    }

                    @if(jobDetails()?.HardCopy){
                      <p class="my-2 text-[#B32D7D] text-sm sm:text-base font-semibold">{{t('hard_copy')}}</p>
                      <div class="text-[#333] sm:leading-6 leading-5 sm:text-sm text-xs" [innerHTML]="hardCopy()">

                      </div>
                    }
                    @if(jobDetails()?.ApplyURL){
                      <p class="my-2 text-[#333] text-sm sm:text-sm font-bold">{{t('apply_url')}}:</p>
                      <div class="hover:text-[#2F64A3] text-[#428bca] text-sm" [innerHTML]="app_url()">
                      </div>
                    }

                    @if(jobDetails()?.WalkInInterview){
                      <p class="my-2 text-[#B32D7D] text-sm sm:text-base font-semibold">{{t('walk_in_interview')}}</p>
                      <div class="text-[#333] sm:leading-7 leading-5 text-sm"
                        [innerHTML]="detailsUtilService.processLinkStyle(jobDetails()!.WalkInInterview)">
                      </div>
                    }
                  </div>

                }
                <app-company-info-card
                  [jobDetails]="jobDetails()"
                  [companyInsight]="companyInsight()"
                  [isFollowedLocal]="isFollowedLocal()"
                  (followClicked)="follow()"
                  />

                <div class="my-2.5">
                  <app-report-job-company
                    [jobAppliedEmail]="jobDetails()?.JobAppliedEmail || '' "
                    [c2c]="jobDetails()?.C2C || '0'"></app-report-job-company>
                </div>
                @if(isBrowser){
                  <div #accessElement>
                    @if((jobDetails()?.AccessibilityAware?.length ?? 0) > 0){
                    <app-accessibility-accordion
                       [accessibilityAware]="jobDetails()?.AccessibilityAware ?? []"
                       (scroll)="scrollToTop()">
                    </app-accessibility-accordion>
                    }
                  </div>
                }
                
                @if(isBrowser && !isProUser()){
                <div class="no-print">
                  <app-banner [banners]="banners()"></app-banner>
                </div>
                }
              </div>
            </div>
          </div>
           @if(isProUser() === false && !isCorporate()){
            <div class=" self-start flex flex-col gap-2">
              <div class="-mt-2">
                <app-ads-panel></app-ads-panel>
              </div>
            </div>
          }
        </div>
      </div>
      @if(!isCorporate() && !isProUser()){
        <div class="hidden lg:block mx-auto sm:w-full w-[100%] lg-width-full md:w-[720px] xl-width-full mx-auto mt-1 pb-40 bg-[#eee]">
          <app-advertise adId="ad-bottom" slotName="/52892455/Adsense/adsns_HorijontalLarge"
            [sizes]="[[728, 90], [970, 90]]">
          </app-advertise>
        </div>
      }
    </div>
  </div>
  }
  }
  @else{
    @if(!isVisible() && !jobDetails()?.Closed){
      <div *transloco="let t; currentLang as currentLang">
        <app-expired-job [text]="'jobExpiredMessage'"></app-expired-job>
      </div>

    }
    @if(statuscode() === '1' || jobDetails()?.Closed){
      <div *transloco="let t; currentLang as currentLang">
        <app-expired-job [text]="'jobUnavailableMessage'"></app-expired-job>
      </div>

    }
  } 
@if(isOverseasModalOpen()){
  <app-overseas-popup
    (modalClose)="isOverseasModalOpen.set(false)"></app-overseas-popup>
}

@if(isMoreJobModalOpen){
<div>
  <app-more-jobs-modal
    (closeModalEmt)="closeMoreJobModal()"
      [jobList]="moreJobs()"
      [jobdetails]="jobDetails()">
  </app-more-jobs-modal>
</div>
}  

    
 -->
@if(isProUser() && fromApplied() || (isShow()) && !isClosed()){
    @if(jobDetails()?.JObIMage){
      <div class="bg-[#eee]">
        <app-newspaper-job-details [jobDetails]="jobDetails()" [jobList]="moreJobs()">
        </app-newspaper-job-details>
      </div>
    }
    @else {
      <div class="bg-[#F7F8F9]">
        <div class="details-page-shell max-md:p-4 mx-auto py-6 bg-[#F7F8F9] flex justify-center gap-6"
          *transloco="let t; currentLang as currentLang">
          <main id="allSection" class="flex-1 w-full xl-width">
            <div id="jobDetailsHeader"
              class="flex-1 w-full max-md:p-3 px-5 pt-4 rounded-[10px] rounded-b-none border border-[#F2F4F7] border-b-0 bg-white shadow-[0_-1px_2px_0_rgba(16,24,40,0.05)]">
              <div class="mb-4 flex items-center justify-between gap-4">
                <button [routerLink]="jobs_url" [queryParams]="{isBack: true}" [class.hidden]="isCorporate()"
                  class="no-print cursor-pointer">
                  <span class="flex items-center gap-1.5 cursor-pointer font-semibold text-sm text-[#344054]">
                    <img src="images/details-chevron-left.svg" alt="" class="h-5 w-5" />
                    <span>{{t('jobList')}}</span>
                  </span>
                </button>
                <div #optionsMenu class="no-print relative">
                  <button type="button" (click)="toggleOptions()"
                    class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-[#E4E7EC] bg-white p-2 shadow-[0_1px_2px_rgba(16,24,40,0.05)] hover:bg-[#F9FAFB]"
                    aria-label="Show job options" [attr.aria-expanded]="isOptionsOpen()">
                    <img src="images/details-dots-vertical.svg" alt="" aria-hidden="true" class="h-5 w-5" />
                  </button>
                  @if (isOptionsOpen()) {
                  <div class="absolute right-0 top-11 z-30 flex min-w-[240px] flex-col gap-1 overflow-hidden rounded-lg border border-[#E4E7EC] bg-white p-2 shadow-[0_1px_2px_rgba(16,24,40,0.05),0_8px_16px_rgba(16,24,40,0.12)]">
                    <button type="button" (click)="isShareModalOpen.set(true); isOptionsOpen.set(false)"
                      class="flex h-10 w-full cursor-pointer items-center gap-2 rounded-md px-3 text-left text-sm font-medium leading-5 text-[#344054] hover:bg-[#F2F4F7]">
                      <img src="images/share-06.svg" alt="" aria-hidden="true" class="h-5 w-5" />
                      {{t('Share')}}
                    </button>
                    <button type="button" (click)="detailsUtilService.triggerPrint(); isOptionsOpen.set(false)"
                      class="flex h-10 w-full cursor-pointer items-center gap-2 rounded-md px-3 text-left text-sm font-medium leading-5 text-[#344054] hover:bg-[#F2F4F7]">
                      <img src="images/printer.svg" alt="" aria-hidden="true" class="h-5 w-5" />
                      {{t('Print')}}
                    </button>
                  </div>
                  }
                </div>
              </div>
              <div class="flex items-center gap-4 mb-4">
                @if(jobDetails()?.JobLOgoName){
                <div class="">
                  <img class="max-w-[48px] max-h-[48px] md:max-w-[80px] md:max-h-[80px] border border-[#E4E7EC] rounded-[10px] aspect-square"
                    [src]="jobDetails()?.JobLOgoName" alt="">
                </div>
                }
                <div appHighlight [searchText]="searchQuery()" class="flex flex-col  gap-1 max-md:min-w-0">
                  <h2 class=" max-md:truncate text-sm md:text-lg font-semibold text-[#101828] leading-7">
                    {{ jobDetails()?.JobTitle }}
                  </h2>
                  <button class="flex gap-1 cursor-pointer"
                    [routerLink]="canNavigateToCompanyInsight() ? '/company-insight/' + jobDetails()?.CompanyID : null">
                    <h2 appHighlight [searchText]="searchQuery()" [class.hover:underline]="canNavigateToCompanyInsight()"
                      class="max-md:truncate flex gap-[2px] sm:gap-[2px]  cursor-pointer text-[#0E6596] text-xs md:text-base font-medium">
                      {{ jobDetails()?.CompnayName }}<span></span>
                    </h2>
                    <img src="images/company-name-share-details-new.gif" alt="share icon"
                      [class.hidden]="!canNavigateToCompanyInsight()"
                      class="-mt-2 block w-[55px] h-[20px] sm:w-[84px] sm:h-[26px] translate-y-[5px] sm:translate-y-[6px]  " />
                  </button>
                </div>
              </div>
              <div class="no-print lg:hidden block my-4">
                <app-matching-section 
                  [jobId]="(jobDetails()?.JobId ?? '')"
                  [matchingData]="MatchingList()"
                  [isMatchingDataReady]="matchingApiCalled()"
                  (matchingDataLoaded)="onMatchingDataLoaded($event)">
                </app-matching-section>
              </div>
              <app-summary [jobDetails]="jobDetails()" (locationClicked)="scrollToJobLocation()">
              </app-summary>
              <div class="bg-[#E4E7EC] w-full mt-4 h-[1px] max-md:hidden"></div>
            </div>
            @if (isShareModalOpen()) {
            <app-share-job-modal [url]="jobUrl" [title]="jobDetails()?.JobTitle || ''" [showWhatsapp]="showWhatsapp()"
              (closed)="isShareModalOpen.set(false)"></app-share-job-modal>
            }
            <div class=" md:sticky max-md:static top-0 z-[20] bg-[#F7F8F9] mx-auto" [class.compact-sticky]="isCompactHeaderVisible()">
              <div
                class="no-print max-md:hidden fixed inset-x-0 top-0 z-[20] w-full bg-white shadow-[0_4px_5px_-3px_rgba(16,24,40,0.12)] transition-all duration-300 ease-in-out"
                [class.translate-y-0]="isCompactHeaderVisible()" [class.opacity-100]="isCompactHeaderVisible()"
                [class.pointer-events-auto]="isCompactHeaderVisible()" [class.translate-y-[-8px]]="!isCompactHeaderVisible()"
                [class.opacity-0]="!isCompactHeaderVisible()" [class.pointer-events-none]="!isCompactHeaderVisible()">
      
                <div
                  class="mx-auto flex w-full top-header-section items-center justify-between gap-3 px-3 py-2 h-[90px] sm:px-4 xl:px-0">
                  <div class="flex min-w-0 items-center gap-3">
                    @if(jobDetails()?.JobLOgoName){
                    <img
                      class="h-10 w-10 shrink-0 rounded-md border border-[#E4E7EC] object-contain sm:h-12 sm:w-12 rounded-[10px]"
                      [src]="jobDetails()?.JobLOgoName" alt="">
                    }
                    <div class="min-w-0">
                      <p [title]="jobDetails()?.JobTitle" class="truncate text-[#101828] font-semibold sm:text-lg">{{
                        jobDetails()?.JobTitle }}</p>
                      <p [title]="jobDetails()?.CompnayName" class="truncate text-xs font-medium text-[#0E6596] sm:text-base">
                        {{ jobDetails()?.CompnayName }}</p>
                    </div>
                  </div>
                  <div class="flex items-center gap-2 sm:gap-4">
                    <div
                      class="flex h-10 w-10 aspect-square items-center justify-center rounded-lg border border-[#E4E7EC] cursor-pointer sm:h-12  hover:bg-[#F9FAFB] sm:w-12 shadow-[inset_0_0_0_1px_rgba(16,24,40,0.18),inset_0_-2px_0_0_rgba(16,24,40,0.05),0_1px_2px_0_rgba(16,24,40,0.05)]"
                      (click)="shortLists()">
                      <img
                        [src]="IsShortlistedLocal() ? environment.homeImageUrl + 'company-insight-saved-icon.svg' : environment.homeImageUrl + 'company-insight-save-jobs-icon.svg'" />
                    </div>
                    @if(jobDetails()?.OnlineApply !=="False" && !remainingData().IsApplied){
                      <button [routerLink]=" shouldNotNavigateToApplyOnline() ? null : '/apply-online/'+ jobDetails()?.JobId"
                        data-testid="compactApplyNowBtn" (click)="!shouldNotNavigateToApplyOnline() && applyOnline()"
                        class="shrink-0 cursor-pointer rounded-[10px] bg-[#008020] hover:bg-[#02651C] px-3 py-3 text-xs font-semibold text-white sm:px-10 sm:text-base">
                        {{t('Apply_Now')}}
                      </button>
                    }

                    @if(remainingData().IsApplied){
                    <a [href]="`${appliedJobsUrl}?jobid=${jobDetails()?.JobId}&type=m&lang=${currentLang}`"
                      class="shadow-sm flex items-center gap-[5px] px-7 py-2.5 font-semibold border border-[#E4E7EC] bg-[#F2F4F7] text-[#98A2B3] rounded-lg sm:text-base text-xs">
                      <!-- <span class="icon-check-sign"></span> -->
                      {{t('Already_Applied')}}
                    </a>
                    }
                  </div>
                </div>
              </div>
              
              <div class="relative w-full transition-all duration-300 ease-in-out xl-width">
                <div [class.translate-y-0]="!isCompactHeaderVisible()" [class.md:opacity-100]="!isCompactHeaderVisible()"
                  [class.pointer-events-auto]="!isCompactHeaderVisible()" [class.translate-y-[-8px]]="isCompactHeaderVisible()"
                  [class.md:opacity-0]="isCompactHeaderVisible()" [class.pointer-events-none]="isCompactHeaderVisible()"
                  class="max-md:flex-col max-md:static flex max-md:gap-3 md:items-center justify-between rounded-[10px] rounded-t-none bg-white px-3 md:px-5 pb-3 md:py-4 shadow-[0_4px_5px_-3px_rgba(16,24,40,0.12)]">
                  <p class="text-xs md:text-sm text-[#344054] lg:text-base">
                    <span class="font-medium">{{ t('Application_Deadline') }} : </span>
                    <span class="font-semibold text-[#101828]">
                      {{ currentLang === 'bn'
                      ? ((jobDetails()?.Deadline | date:'dd MMM yyyy') ?? '' | toBanglaNumber)
                      : (jobDetails()?.Deadline | date:'dd MMM yyyy') }}
                    </span>
                  </p>
                  <div class="no-print flex items-center gap-2 sm:gap-4">
                  <div
                    class="flex h-10 w-10 aspect-square items-center justify-center rounded-lg border border-[#E4E7EC] cursor-pointer sm:h-12 sm:w-12 shadow-[inset_0_0_0_1px_rgba(16,24,40,0.18),inset_0_-2px_0_0_rgba(16,24,40,0.05),0_1px_2px_0_rgba(16,24,40,0.05)] hover:bg-[#F9FAFB]"
                    role="button" (click)="shortLists()" [title]="IsShortlistedLocal() ? t('removeSavedJob') : t('saveThisJob')"
                    [attr.aria-label]="IsShortlistedLocal() ? t('removeSavedJob') : t('saveThisJob')">
                  
                      <img [src]="IsShortlistedLocal()
                        ? environment.homeImageUrl + 'company-insight-saved-icon.svg'
                        : environment.homeImageUrl + 'company-insight-save-jobs-icon.svg'" alt="" />
                    </div>              @if(jobDetails()?.OnlineApply !=="False" && !remainingData().IsApplied){
                    <button [routerLink]=" shouldNotNavigateToApplyOnline() ? null : '/apply-online/'+ jobDetails()?.JobId"
                      data-testid="applyNowBtn" (click)="!shouldNotNavigateToApplyOnline() && applyOnline()"
                      class="shrink-0 cursor-pointer rounded-[10px] bg-[#008020] max-md:flex-1 max-md:w-full hover:bg-[#02651C] px-10 md:w-fit py-3 text-xs font-semibold text-white sm:px-10 sm:text-base">
                      {{t('Apply_Now')}}
                    </button>
                    }
                    @if(remainingData().IsApplied){
              
                    <a [href]="`${appliedJobsUrl}?jobid=${jobDetails()?.JobId}&type=m&lang=${currentLang}`"
                    class="shadow-sm flex items-center gap-[5px] px-7 py-2.5 font-semibold border border-[#E4E7EC] bg-[#F2F4F7]
                    text-[#98A2B3] rounded-lg sm:text-base text-xs max-md:flex-1 max-md:justify-center max-md:w-full">
                    {{t('Already_Applied')}}
                    </a>
                    }
                  </div>
                </div>

                <div [class.translate-y-full]="!isCompactHeaderVisible()" [class.opacity-0]="!isCompactHeaderVisible()"
                  [class.pointer-events-none]="!isCompactHeaderVisible()" [class.translate-y-0]="isCompactHeaderVisible()"
                  [class.opacity-100]="isCompactHeaderVisible()" [class.pointer-events-auto]="isCompactHeaderVisible()" class="no-print md:hidden fixed bottom-0 left-0 right-0 z-40 flex items-center gap-2 bg-white px-3 py-3
                         shadow-[0_-4px_10px_-3px_rgba(16,24,40,0.15)] transition-all duration-300 ease-in-out">
                  <div
                    class="flex h-10 w-10 shrink-0 aspect-square items-center justify-center rounded-lg border border-[#E4E7EC] cursor-pointer shadow-[inset_0_0_0_1px_rgba(16,24,40,0.18),inset_0_-2px_0_0_rgba(16,24,40,0.05),0_1px_2px_0_rgba(16,24,40,0.05)]"
                    (click)="shortLists()">
                    <img
                      [src]="IsShortlistedLocal() ? environment.homeImageUrl + 'company-insight-saved-icon.svg' : environment.homeImageUrl + 'company-insight-save-jobs-icon.svg'" />
                  </div>
                  @if(jobDetails()?.OnlineApply !=="False" && !remainingData().IsApplied){
                  <button [routerLink]=" shouldNotNavigateToApplyOnline() ? null : '/apply-online/'+ jobDetails()?.JobId"
                    (click)="!shouldNotNavigateToApplyOnline() && applyOnline()"
                    class="flex-1 cursor-pointer rounded-[10px] bg-[#008020] hover:bg-[#02651C] px-10 py-3 text-xs font-semibold text-white">
                    {{t('Apply_Now')}}
                  </button>
                  }
                  @if(remainingData().IsApplied){
                    <a [href]="`${appliedJobsUrl}?jobid=${jobDetails()?.JobId}&type=m&lang=${currentLang}`"
                    class="flex-1 flex items-center justify-center gap-[5px] px-7 py-2.5 font-semibold border border-[#E4E7EC]
                    bg-[#F2F4F7] text-[#98A2B3] rounded-lg text-xs">
                    {{t('Already_Applied')}}
                    </a>
                  }
                </div>

                @if (jobDetails()?.PreferVideoResume !== 0) {
                <div [class.md:hidden]="isCompactHeaderVisible()"
                  class="mt-4 md:mt-6 m-0 px-3 md:px-5 py-2.5 flex items-center gap-2 rounded-[10px] border-[0.5px] border-[#95CDFF] bg-[#ECF6FF] text-[#2F64A3] text-sm sm:text-base font-normal font-inter">
                  <img src="images/custom_cv.svg" alt="video resume icon" class="h-5 w-5" />
                  @if(transloco.getActiveLang() === 'en'){
                  <p>Applicants are encouraged to submit <b>Video CV.</b></p>
                  }@else {
                  <p>অ্যাপ্লিকেন্টদের <b>ভিডিও সিভি</b> সাবমিট করতে উৎসাহিত করা হচ্ছে।</p>
                  }
                </div>
                }
              
              <div [class.md:mt-2]="isCompactHeaderVisible()"
                [class.md:pt-6]="!isCompactHeaderVisible()"
                [class.md:pt-4]="isCompactHeaderVisible()" 
                class="no-print pt-4 pb-2  md:pb-4 md:block hidden">
                <nav
                  class="flex items-center gap-1 rounded-[10px] bg-[#ECEDEE] px-2 py-1 md:p-1 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-smooth scrollbar-hide w-full">
                  @for (section of visibleSections(); track section.id) {
                  <button #tabBtn [attr.data-section-id]="section.id" type="button"
                    class="flex-1 shrink-0 snap-start whitespace-nowrap hover:text-[#101828] flex items-center justify-center rounded-[10px] px-3 py-2 text-xs md:text-sm font-medium transition-all cursor-pointer"
                    [class.bg-white]="activeSection() === section.id" [class.text-[#0E73A9]]="activeSection() === section.id"
                    [class.shadow-sm]="activeSection() === section.id" [class.text-[#344054]]="activeSection() !== section.id"
                    (click)="scrollToSections(section.id)">
                    {{ t(section.labelKey) }}
                  </button>
                  }
                </nav>
              </div>
              </div>
              
            </div>
            <div [class.md:mt-2]="isCompactHeaderVisible()"
              class="no-print max-md:block hidden pt-4 pb-2 md:pt-6 md:pb-4
                                 max-md:sticky max-md:top-0 max-md:z-30 bg-[#F7F8F9]">
              <nav #navContainer
                class="flex md:grid gap-1 rounded-[10px] bg-[#ECEDEE] px-2 py-1 md:p-1 overflow-x-auto md:overflow-visible snap-x snap-mandatory scroll-smooth scroll-px-1 scrollbar-hide"
                [style.grid-template-columns]="
                                  visibleSections().length > 1
                                    ? '120px repeat(' +
                                      (visibleSections().length - 1) +
                                      ', minmax(0, 1fr))'
                                    : '120px'
                                ">
                @for (section of visibleSections(); track section.id) {
                <button #tabBtn [attr.data-section-id]="section.id" type="button"
                  class="shrink-0 mx-1 snap-start whitespace-nowrap min-w-[100px] md:min-w-0 md:w-auto rounded-[10px] px-3 py-2 text-xs md:text-sm font-medium transition-all cursor-pointer"
                  [class.bg-white]="activeSection() === section.id" [class.text-[#0E73A9]]="activeSection() === section.id"
                  [class.shadow-sm]="activeSection() === section.id" [class.text-[#344054]]="activeSection() !== section.id"
                  (click)="scrollToSections(section.id)">
              {{ t(section.labelKey) }}
                </button>
                }
              </nav>
            </div>
            <div class="no-print block">
              @defer (on viewport; on idle) {
              <div class="relative ">
                <app-application-insights [topApplicantMatchingPercentage]="topApplicantMatchingPercentage()"
                  [applicantMatchingScore]="applicantMatchingScore()" [isApplied]="remainingData().IsApplied"
                  [(matchingData)]="matchingData">
                </app-application-insights>
              </div>
      
              } @placeholder {
              <div class="h-14"></div>
              }
            </div>
            <div class="mt-4 md:mt-6">
              <app-details-main [keyword]="searchQuery()" [jobDetails]="jobDetails()">
              </app-details-main>
            </div>
            @if(jobDetails()?.JobKeyPoints){
            <div class="bg-white md:my-6 my-4 px-3 sm:px-5 py-2.5 border-[1.5px] border-solid border-[#F2F4F7] rounded-[10px] ">
              <p class="mb-2.5 text-[#0E73A9] text-xs sm:text-base font-semibold">{{t('job_highlights')}}</p>
              <div class="sm:leading-8 leading-5 sm:text-sm text-xs text-[#344054]" [innerHTML]="jobDetails()?.JobKeyPoints">
              </div>
            </div>
            }
            @if(jobDetails()?.ApplyInstruction){
            <div class="bg-[#F1F9FE] md:my-6 my-4 px-3 sm:px-5 py-3 border  border-[#E4E7EC] rounded-[10px]">
              <p class="mb-2.5 text-[#0E73A9] text-sm sm:text-base font-semibold">
                {{t('read_before_apply')}}
              </p>
              <div class="sm:leading-7 leading-5 sm:text-sm text-xs text-[#344054]"
                [innerHTML]="jobDetails()?.ApplyInstruction">
              </div>
            </div>
            }
      
            @if(jobDetails()?.ApplyEmail || jobDetails()?.ApplyURL
            || jobDetails()?.WalkInInterview || jobDetails()?.HardCopy){
            <div class="md:my-6 my-4 border-1.5 border-solid border-[#E4E7EC] bg-white rounded-lg px-3 sm:px-5 py-2.5 mb-6">
              <p class="mb-2 md:mb-4 text-[#0E73A9] text-sm sm:text-base font-semibold">{{t('apply_procedure')}}</p>
              @if(jobDetails()?.ApplyEmail){
              <p class="mb-1.5 md:mb-2.5 text-[#101828] text-sm sm:text-sm font-medium">{{t('email_your_cv')}}</p>
              <p class="text-xs sm:text-sm text-[#333]">
                <span>{{detailsUtilService.getTextSegments(jobDetails()?.ApplyEmail ?? '').emailText}}</span>
                @if(detailsUtilService.getTextSegments(jobDetails()?.ApplyEmail ?? '').strongText){
                or Email your CV from <a [href]="`${emailCvUrl}?id=${jobDetails()?.JobId}&lang=${currentLang}`"
                  target="_blank"
                  class="font-bold text-[#0E73A9] cursor-pointer">{{detailsUtilService.getTextSegments(jobDetails()?.ApplyEmail
                  ?? '').strongText}}</a>
                account
                }
              </p>
              }
      
              @if(jobDetails()?.HardCopy){
              <p class="mb-1.5 md:mb-2.5 text-[#101828] text-sm sm:text-same font-medium">{{t('hard_copy')}}</p>
              <div class="text-[#344054] sm:leading-6 leading-5 sm:text-sm text-xs" [innerHTML]="hardCopy()">
              </div>
              }
      
              @if(jobDetails()?.ApplyURL){
              <p class="mb-1.5 md:mb-2.5 text-[#101828] text-sm sm:text-same font-medium">{{t('apply_url')}}:</p>
              <div class="hover:text-[#10557C] text-[#0E73A9] text-xs md:text-sm" [innerHTML]="app_url()">
              </div>
              }
      
              @if(jobDetails()?.WalkInInterview){
              <p class="mb-1.5 md:my-2.5 text-[#101828] text-sm sm:text-same font-medium">{{t('walk_in_interview')}}</p>
              <div class="text-[#344054] sm:leading-7 leading-5 text-xs md:text-sm"
                [innerHTML]="detailsUtilService.processLinkStyle(jobDetails()!.WalkInInterview)">
              </div>
              }
            </div>
            }
      
            @if(isBrowser){
            <div class="no-print lg:hidden">
            <app-company-info-card [jobDetails]="jobDetails()" [companyInsight]="companyInsight()"
              [isFollowedLocal]="isFollowedLocal()" (followClicked)="follow()" />
            </div>
            <div class="mt-6">
              <app-report-job-company [jobAppliedEmail]="jobDetails()?.JobAppliedEmail || '' ">
              </app-report-job-company>
            </div>
            <div #accessElement>
              @if((jobDetails()?.AccessibilityAware?.length ?? 0) > 0){
              <app-accessibility-accordion [accessibilityAware]="jobDetails()?.AccessibilityAware ?? []"
                (scroll)="scrollToTop()">
              </app-accessibility-accordion>
              }
            </div>
            }

            @if(isBrowser && !isProUser()){
            <div class="no-print my-6">
              <app-banner [banners]="banners()"></app-banner>
            </div>
            }
      
            @if(!isCorporate() && !isProUser()){
            <div class="hidden lg:block mx-auto sm:w-full lg:max-w-[946px] md:w-[720px] xl-width-full min-h-[90px] ">
              <app-advertise adId="ad-bottom" slotName="/52892455/Adsense/adsns_HorijontalLarge"
                [sizes]="[[728, 90], [970, 90]]">
              </app-advertise>
            </div>
            }
          </main>
      
          <aside class="no-print min-w-[320px] max-w-[320px] lg:block hidden">
            <div class="flex flex-col gap-6 items-center">
              <div>
                <app-matching-section 
                  [jobId]="(jobDetails()?.JobId ?? '')"
                  [matchingData]="MatchingList()"
                  [isMatchingDataReady]="matchingApiCalled()"
                  (matchingDataLoaded)="onMatchingDataLoaded($event)">
                </app-matching-section>
              </div>
              <div class="hidden lg:block min-w-[320px]">
                <app-company-info-card [jobDetails]="jobDetails()" [companyInsight]="companyInsight()"
                  [isFollowedLocal]="isFollowedLocal()" (followClicked)="follow()" />
              </div>
              @if(isProUser() === false && !isCorporate()){
              <div class=" flex flex-col gap-2">
                <div class="-mt-2">
                  <app-ads-panel></app-ads-panel>
                </div>
              </div>
              }
            </div>
          </aside>
        </div>
      </div>
    }
}@else{
  @if(!isVisible() && !jobDetails()?.Closed){
  <div *transloco="let t; currentLang as currentLang">
    <app-expired-job [text]="'jobExpiredMessage'"></app-expired-job>
  </div>

  }
  @if(statuscode() === '1' || jobDetails()?.Closed){
  <div *transloco="let t; currentLang as currentLang">
    <app-expired-job [text]="'jobUnavailableMessage'"></app-expired-job>
  </div>

  }
}


@if(isOverseasModalOpen()){
  <app-overseas-popup (modalClose)="isOverseasModalOpen.set(false)"></app-overseas-popup>
}
